import request from '@/services/interceptor.js'

export const valida = (par) => {
    return request({
        url: '/timbratura/validate',
        method: 'post',
        data: par,
        loadingBar: false
    })
}

export const getStatus = (par) => {
    return request({
        url: '/timbratura/status',
        method: 'post',
        data: par,
        loadingBar: false
    })
}

export const validaOffline = (data) => {
    return request({
        url: '/timbratura/validate-offline',
        method: 'post',
        data: data,
        loadingBar: false
    })
}